import QuickSearch from './quick';

// import searchProvider, {
//   DEVICE_DOMAIN,
// } from './provider';

// export {
//   QuickSearch,
//  searchProvider,
//  DEVICE_DOMAIN,
// };

export default QuickSearch;
